<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/3ALDkz/media/FC-9798889105800.jpg?1720819934083" alt="This image is the cover for the book The Coming of the Train"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Coming of the Train
      </h1>
      <p class="bookDescription body article font2">
        <p style='margin-top:0cm;margin-right:0cm;margin-bottom:8.0pt;margin-left:0cm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:16px;font-family:"Times New Roman",serif;'>Embark on a universal voyage through the rich tapestry of human experience, a narrative that mirrors your own life’s saga. This book captures the essence of existence, our collective tales of joy and sorrow, love and loss, and the myriad decisions that shape our days. From the rollercoaster ride of adolescence to the serenity of our twilight years, each chapter resonates with a truth you’ve lived: the thrill of love, the search for self, the grief of goodbyes, and the introspection in life’s quiet moments. The author weaves these shared threads into a story that feels deeply personal, reflecting the shifting landscapes of our lives. Readers will see themselves on these pages, finding comfort, inspiration, and a reflection of their journey in a life that, while unique, is connected by common threads to all. This story promises to tug at your heartstrings, provoke thought, and perhaps draw a tear or a smile, reminding you of the profound simplicity of being human.</span></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Tom Turner
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0cm;text-align:justify;font-size:15px;font-family:"Times New Roman",serif;'>Tom Turner grew up in rural Ohio, leaving as a young man to attend West Point. After military service, he spent many years working in corporate America in senior management positions. He has been married for nearly 50 years, with three children and three grandchildren, and has lived in North Carolina for almost 40 years. He likes golf, writing, selling real estate, and date nights with his wife.</p><p><span style='font-size:15px;font-family:"Times New Roman",serif;'><br></span></p><p style='margin: 0mm 0mm 0.0001pt; text-align: justify; font-size: 15px; font-family: "Times New Roman", serif;'><br></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?bac53220